module.exports = __webpack_public_path__ + "static/marka_wlasna-503b34c658cc0c0f67248d4f6a8c256b.png";